module.exports = __webpack_public_path__ + "static/media/technology-icon-collect.f14c84a9.png";